// extracted by mini-css-extract-plugin
export default {"close":"Alert_close__Om-kJ"};